import { Col, Input, Row } from "reactstrap"
import PrimaryButton from "../../../../../components/common/PrimaryButton/PrimaryButton"
import Toggle from "../../../../../components/common/Toggle/Toggle"
import { CreditCard } from "react-feather"
import { CiBank } from "react-icons/ci"
import Maelano from "../../../../../assets/icons/MaelanoIcon.png"
import CreditCardImg from "../../../../../assets/images/SellerPortalImages/Services/credit-card.png"
import BlueTick from "../../../../../assets/images/SellerPortalImages/Subscription/blue-tick.png"
import styles from "./CurrentSubscription.module.scss"
import Divider from "../../../../../components/common/Divider/Divider"
import { CiLock } from "react-icons/ci"
import { useState } from "react"
import CancelModal from "./CancelModal/CancelModal"
import PauseModal from "./PauseModal/PauseModal"

const CurrentSubscription = () => {

  const paymentOptions = [
    { icon: CreditCard, label: "Credit Card" },
    { icon: CiBank, label: "Bank Transfer" },
    { icon: Maelano, label: "My Wallet" },
  ]

  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false)
  const [isPauseModalOpen, setIsPauseModalOpen] = useState(false)

  return (
    <div className="bg-white p-3 rounded mt-3">
      <div className="d-flex justify-content-between align-items-center">
        <div className="fw-semibold fs-4">Current Subscription Plan</div>

        <div>
          <PrimaryButton name={"Save Plan"} colorTheme="yellow" />
        </div>
      </div>

      <Row className="mt-3">
        <Col xs='12' lg='8'>
          <div className="d-flex justify-content-between align-items-lg-center align-items-start gap-2 gap-lg-0 flex-column flex-lg-row">
            <div className="d-flex gap-2">
              <div>
                <PrimaryButton name={"Manage Subscription"} colorTheme="black" />
              </div>
              <div>
                <PrimaryButton name={"Renew Subscription"} colorTheme="blue" />
              </div>
            </div>

            <div className="d-flex gap-2">
              <div>
                <PrimaryButton name={"Pause"} colorTheme="outline" onClick={() => setIsPauseModalOpen(true)} />
              </div>
              <div>
                <PrimaryButton name={"Cancel"} colorTheme="outline" onClick={() => setIsCancelModalOpen(true)} />
              </div>
            </div>
          </div>

          <div className="border rounded mt-3 p-3">
            <div className="fs-4">Details</div>

            <div className="d-flex align-items-center justify-content-between mt-3">
              <label htmlFor="billedTo" className="fw-medium text-muted">
                Billed To
              </label>
              <div className="d-flex gap-2">
                <div>Auto-Renewel</div>
                <Toggle />
              </div>
            </div>

            <div className="mt-2">
              <Input type="text" placeholder="Your Name" style={{ padding: ".7rem" }} />
            </div>

            <label className="fw-medium my-3 text-muted">Payment Details</label>
            <Row>
              {paymentOptions.map((option) => (
                <Col xs="4">
                  <div style={{ border: "1px solid #E1E6EF", borderRadius: "12px", padding: "1rem" }}>
                    <div>
                      {typeof option.icon === "string" ? <img src={option.icon} alt={option.label} width={35} height={30} /> : <option.icon size={30} />}
                    </div>
                    <div className="mt-2">{option.label}</div>
                  </div>
                </Col>
              ))}
            </Row>

            <div className="mt-2 position-relative">
              <Input type="text" value={"6508 8234 3354 7832"} style={{ padding: ".7rem", paddingLeft: "3.5rem" }} />
              <img src={CreditCardImg} alt="" style={{ position: "absolute", top: "1rem", left: "1rem" }} />
            </div>
            <Row>
              <Col>
                <div className="mt-2">
                  <Input type="text" placeholder="Expiry date" style={{ padding: ".7rem" }} />
                </div>
              </Col>
              <Col>
                <div className="mt-2">
                  <Input type="text" placeholder="CVV" style={{ padding: ".7rem" }} />
                </div>
              </Col>
            </Row>

            <div className="mt-2">
              <Input type="text" placeholder="Country" style={{ padding: ".7rem" }} />
            </div>
            <div className="mt-2">
              <Input type="text" placeholder="24783" style={{ padding: ".7rem" }} />
            </div>
          </div>
        </Col>
        <Col xs="12" lg='4'>
          <div className={styles["right-side-wrapper"]}>
            <div className="fw-semibold fs-4">Local Seller</div>
            <div className="fw-medium mt-2">
              Subscription Ending on: <span className={styles["text-orange"]}>8 Oct 2024</span>
            </div>

            <div className={`d-flex gap-3 align-items-center justify-content-between ${styles["payment-time"]} mt-2`}>
              <div className="d-flex align-items-center gap-2">
                <div>
                  <Input name="pay" type="radio" className={styles["form-check-input"]} />
                </div>
                <div>
                  <div className="fs-5">Pay Monthly</div>
                  <div className="text-muted">$20 / Month</div>
                </div>
              </div>
            </div>

            <div className={`d-flex gap-3 align-items-center justify-content-between ${styles["payment-time"]} mt-3`}>
              <div className="d-flex align-items-center gap-2">
                <div>
                  <Input name="pay" type="radio" className={styles["form-check-input"]} />
                </div>
                <div>
                  <div className="fs-5">Pay Annual</div>
                  <div className="text-muted">$16 / Month</div>
                </div>
              </div>
              <div className={styles.save}>Save 15%</div>
            </div>

            <Divider />

            <div className="d-flex align-items-center justify-content-between fs-3">
              <div>Total</div>
              <div>$20/month</div>
            </div>

            <div className="text-muted d-flex gap-2 mt-3">
              <div>
                <CiLock size={20} />
              </div>
              <div>Guaranteed to be safe & secure, ensuring that all transactions are protected with the highest level of security.</div>
            </div>

            <div className="fs-5 my-3">Benefits</div>

            <div className="d-flex gap-2 align-items-center">
              <img src={BlueTick} alt="" />
              <div>Access to seller dashboard.</div>
            </div>
            <div className="d-flex gap-2 align-items-center mt-1">
              <img src={BlueTick} alt="" />
              <div>Product listing management.</div>
            </div>
            <div className="d-flex gap-2 align-items-center mt-1">
              <img src={BlueTick} alt="" />
              <div>Basic customer support.</div>
            </div>
            <div className="d-flex gap-2 align-items-center mt-1">
              <img src={BlueTick} alt="" />
              <div>Marketing options.</div>
            </div>
            <div className="d-flex gap-2 align-items-center mt-1">
              <img src={BlueTick} alt="" />
              <div>Analytics and reporting tools.</div>
            </div>
          </div>
        </Col>
      </Row>

      <CancelModal isModalOpen={isCancelModalOpen} setIsModalOpen={setIsCancelModalOpen} />
      <PauseModal isModalOpen={isPauseModalOpen} setIsModalOpen={setIsPauseModalOpen} />
    </div>
  )
}

export default CurrentSubscription
